import React from 'react'
import { Switch } from 'react-router-dom'
import AppRoute from './AppRoute'
import MainLayout from 'layouts/MainLayout/MainLayout'
import SigninContainer from './Signin/containers/SigninContainer'
import SignupContainer from './Signup/containers/SignupContainer'
import ResetPasswordContainer from './ResetPassword/containers/ResetPasswordContainer'
import BoardingContainer from './Boarding/containers/BoardingContainer'
import HomeContainer from './Home/containers/HomeContainer'
import ProductsContainer from './Products/containers/ProductsContainer'
import LockersContainer from './Lockers/containers/LockersContainer'
import CustomersContainer from './Customers/containers/CustomersContainer'
import HistoryContainer from './History/containers/HistoryContainer'
import TableContainer from './Table/containers/TableContainer'
import BarContainer from './Bar/containers/BarContainer'
import AdminRouter from './Admin'
import AdminLayout from 'layouts/AdminLayout/AdminLayout'
import SigninLayout from 'layouts/SigninLayout/SigninLayout'
import BoardingLayout from 'layouts/BoardingLayout/BoardingLayout'
import CommonModalConductor from 'containers/CommonModalConductor'
// import LoginRoute from './Login'
// import SignUpRoute from './SignUp'
// import HomeRoute from './Home'
// import ProductsRoute from './Products'
// import LockersRoute from './Lockers'
// import CustomersRoute from './Customers'
// import HistoryRoute from './History'
// import AdminRoute from './Admin'
// import TableRoute from './Table'
// import BarRoute from './Bar'
// import BoardingRoute from './Boarding'
// import ResetPasswordRoute from './ResetPassword'
export default () => (
  <React.Fragment>
    <CommonModalConductor />
    <Switch>
      <AppRoute path="/admin" layout={AdminLayout} component={AdminRouter} />
      <AppRoute
        exact
        path="/signup"
        layout={SigninLayout}
        component={SignupContainer}
      />
      <AppRoute
        exact
        path="/signin"
        layout={SigninLayout}
        component={SigninContainer}
      />
      <AppRoute
        exact
        path="/resetPassword"
        layout={SigninLayout}
        component={ResetPasswordContainer}
      />
      <AppRoute
        exact
        path="/boarding"
        layout={BoardingLayout}
        component={BoardingContainer}
      />
      <AppRoute
        exact
        path="/home"
        layout={MainLayout}
        component={HomeContainer}
      />
      <AppRoute
        exact
        path="/home/:tabId"
        layout={MainLayout}
        component={HomeContainer}
      />
      <AppRoute
        exact
        path="/table/:tableId"
        layout={MainLayout}
        component={TableContainer}
      />
      <AppRoute
        exact
        path="/bar/:barId"
        layout={MainLayout}
        component={BarContainer}
      />
      <AppRoute
        exact
        path="/products"
        layout={MainLayout}
        component={ProductsContainer}
      />
      <AppRoute
        exact
        path="/customers"
        layout={MainLayout}
        component={CustomersContainer}
      />
      <AppRoute
        exact
        path="/lockers"
        layout={MainLayout}
        component={LockersContainer}
      />
      <AppRoute
        exact
        path="/history"
        layout={MainLayout}
        component={HistoryContainer}
      />
    </Switch>
  </React.Fragment>
)
// export const createRoutes = store => [
//   {
//     path: '/',
//     component: CoreLayout,
//     indexRoute: {
//       component: MainLayout,
//       childRoutes: [HomeRoute(store)]
//     },
//     childRoutes: [
//       {
//         component: BoardingLayout,
//         childRoutes: [BoardingRoute(store)]
//       },
//       {
//         component: AdminLayout,
//         childRoutes: [AdminRoute(store)]
//       },
//       {
//         component: SigninLayout,
//         childRoutes: [LoginRoute(store)]
//       },
//       {
//         component: SigninLayout,
//         childRoutes: [SignUpRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [HomeRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [ProductsRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [LockersRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [CustomersRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [TableRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [BarRoute(store)]
//       },
//       {
//         component: MainLayout,
//         childRoutes: [HistoryRoute(store)]
//       },
//       {
//         component: SigninLayout,
//         childRoutes: [ResetPasswordRoute(store)]
//       },
//       {
//         path: '*',
//         redirect: '/home'
//       }
//     ]
//   }
// ]



// WEBPACK FOOTER //
// ./src/routes/index.js